const initState = () => {
  return {
    sent: null,
    inbox: null,
  };
}

const emails = (state=initState(), action) => {
  switch (action.type) {

    case "INIT_SENT_EMAILS":
      return {...state, ...{sent: action.payload}}

    case "INIT_INBOX_EMAILS":
      return {...state, ...{inbox: action.payload}}

    default:
      return state;
  }
}

export default emails;
